import React, { useEffect } from 'react';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      window.addEventListener('keydown', handleEscape);
    }
    return () => window.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-174">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-[#1a3a52]/80 backdrop-blur-sm animate-fade-in" onClick={onClose} aria-hidden="true" data-id="element-175" />

      {/* Modal Content */}
      <div className="relative bg-[#f5f1e8] rounded-2xl shadow-2xl w-full max-w-2xl max-h-[85vh] overflow-hidden animate-scale-in" data-id="element-176">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-[#1a3a52]/10" data-id="element-177">
          <h2 id="modal-title" className="text-2xl font-serif font-bold text-[#1a3a52]" data-id="element-178">
            {title}
          </h2>
          <button onClick={onClose} className="p-2 rounded-full text-[#1a3a52]/60 hover:text-[#1a3a52] hover:bg-[#1a3a52]/10 transition-colors" aria-label="Cerrar" data-id="element-179">
            <X className="w-5 h-5" data-id="element-180" />
          </button>
        </div>

        {/* Body */}
        <div className="p-6 overflow-y-auto max-h-[calc(85vh-88px)] text-[#1a3a52]/80" data-id="element-181">
          {children}
        </div>
      </div>
    </div>;
}